var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 6,
    viewBox: "0 0 13 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-954 -945)",
    clipPath: "url(#Polygone_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygone_2",
    "data-name": "Polygone 2",
    d: "M8.995,1.72a2,2,0,0,1,3.01,0L18.1,8.683A2,2,0,0,1,16.592,12H4.408A2,2,0,0,1,2.9,8.683Z",
    transform: "translate(971 952) rotate(180)",
    fill: "#0e28a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.146ba786de5ad443985db4a26ad085ed.svg";
export { ForwardRef as ReactComponent };